<div class="w-full flex flex-col">
  <div class="flex-auto items-center md:items-start sm:justify-center md:justify-start">
    <div class="flex items-center justify-center w-full banner bg-center bg-cover"
      style="background-image: url({{this.headerImage}});">
      <div class="flex max:w-2/3 justify-center items-center flex-col p-4">
        <h1 class="text-white text-center md:text-6xl font-bold text-4xl max-sm:text-left">
          {{headerText}}
        </h1>
      </div>
    </div>
    <div class="flex flex-col lg:m-14 max-sm:my-12 mx-4 md:px-40">
      <div class="flex lg:flex-row flex-col justify-between max-sm:space-y-8">
        <div class="flex flex-col space-y-4">
          <h1 class="font-bold text-2xl">
            Client Care
          </h1>
          <div class="flex flex-col text-primary space-y-4">
            <div class="flex flex-row items-center space-x-4">
              <mat-icon class="text-primary"> access_time </mat-icon>
              <div class="flex flex-col">
                <h1 class="font-bold">
                  Client Support
                </h1>
                <p>
                  Monday - Friday: 08:00 - 20:00
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col space-y-4">
          <h1 class="font-bold text-2xl">
            Technical support
          </h1>
          <div class="flex flex-col text-primary space-y-4">
            <div class="flex flex-row items-center space-x-4">
              <mat-icon class="text-primary"> access_time </mat-icon>
              <div class="flex flex-col">
                <h1 class="font-bold">
                  Technical Support
                </h1>
                <p>
                  Monday - Sunday: 08:00 - 20:00
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col space-y-4">
          <h1 class="font-bold text-2xl">
            Account queries
          </h1>
          <div class="flex flex-col text-primary space-y-4">
            <div class="flex flex-row items-center space-x-4">
              <mat-icon class="text-primary"> access_time </mat-icon>
              <div class="flex flex-col">
                <h1 class="font-bold">
                  Account  Support
                </h1>
                <p>
                  Monday - Friday: 08:00 - 17:00
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <fuse-card class="w-full bg-primary p-8 rounded-md mt-14">
        <div class="flex lg:flex-row lg:space-x-32 w-full lg:items-center flex-col max-sm:space-y-4 justify-between">
          <div class="flex flex-row items-center space-x-4 text-white">
            <mat-icon class="text-white"> phone </mat-icon>
            <div class="flex flex-col">
              <h1>
                General Support: <a href="tel:0861787377" class="font-bold hover:cursor-pointer">0861 787 377</a>
              </h1>
            </div>
          </div>
          <div class="flex flex-row space-x-4 items-center">
            <mat-icon class="text-white"> access_time </mat-icon>
            <div class="flex flex-col">
              <h1 class="font-bold text-white">
                Sales and order follow up Operating hours
              </h1>
              <p class="text-white">
                Monday - Friday: 08:00 - 17:00
              </p>
              <p class="text-white">
                Saturdays: 08:00 - 14:00
              </p>
            </div>
          </div>
          <div class="flex flex-row items-center space-x-4 text-white">
            <mat-icon class="text-white" svgIcon="heroicons_outline:hand-thumb-down"></mat-icon>
            <div class="flex flex-col">
              <h1>
                <a routerLink="/contact-us/complaints" class="font-bold hover:cursor-pointer">Supersonic Complaints</a>
              </h1>
            </div>
          </div>
        </div>
      </fuse-card>
    </div>
  </div>
</div>